import React, { useState, useEffect } from "react";

import NavbarPage from "../components/NavbarPage";
import CarouselPage from "../components/CarouselPage";
import Productos from "../components/Productos";


import {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBListGroup,
    MDBListGroupItem,
    MDBBadge,
    MDBCard,
    MDBScrollbar,
} from "mdbreact";

import FooterPage from "../components/FooterPage";
import NavbarPageCategoria from "../components/NavbarPageCategoria";
import url from "../components/config/Config";

import img from "../images/banner-4.webp";
import "../styles/style-general.css";
import { useHistory, Link } from "react-router-dom";
import Publicidad from "./Publicidad";
import ProductosMain from "../components/main/ProductosMain";
import CarouselCategoriasMain from "../components/main/CarouselCategorias";

const Main = ({
    listaBanner = [],
    listaCategoriasItems = [],
    listaAllProductos = [],
}) => {
    const [listProductFilteredCategory, setListProductFiltered] = useState([]);
    const [currentBannerIndex, setCurrentBannerIndex] = useState(0); // Estado para el índice del banner actual

    const history = useHistory();

    useEffect(() => {
        if (listaBanner.length > 0) {
            const interval = setInterval(() => {
                setCurrentBannerIndex((prevIndex) =>
                    prevIndex === listaBanner.length - 1 ? 0 : prevIndex + 1
                );
            }, 3000); // Cambia el banner cada 1 segundo

            return () => clearInterval(interval); // Limpiar el intervalo al desmontar el componente
        }
    }, [listaBanner]);

    const categoryClick = (item) => {
        var url =
            `/categoria/${item.IdCategoria}/${item.Nombre}/1` +
            "?e=".concat(localStorage.getItem("empresa"));
        history.push(url);
    };

    const categoryClickMain = (categoria) => {
        let listTemp = listaAllProductos.filter(
            (item) => item.idcategoria == categoria.IdCategoria
        );

        listTemp = listTemp.map((item) => ({
            ...item,
            nombre: url.capitalizeWords(item.nombre),
            codigo: url.capitalizeWords(item.codigo),
        }));
        console.log(listTemp);
        setListProductFiltered(listTemp);
    };

    return (
        <div style={{ backgroundColor: "#f3f4f6" }}>
            <CarouselPage listaBanner={listaBanner} />

            <div className="bg-secondary-personalize p-2 lg:p-4 flex justify-center gap-10">
                <div className="flex items-center gap-2">
                    <i className="fas fa-credit-card text-2xl"></i>
                    <p className="hidden lg:block font-bold">Pagos 100% seguros</p>
                </div>
                <div className="flex items-center gap-2">
                    <i className="fas fa-truck text-2xl"></i>
                    <p className="font-bold">Envío gratis</p>
                </div>
                <div className="flex items-center gap-2">
                    <i className="fas fa-shield-alt text-2xl"></i>
                    <p className="hidden lg:block  font-bold">Garantía</p>
                </div>
            </div>
            
            <CarouselCategoriasMain
                listaCategoriasItems={listaCategoriasItems}
                categoryClick={categoryClick}
            />
           
           <div className="bg-white">
                <div className="p-2 lg:p-12 max-w-7xl mx-auto ">
                    <div className="grid grid-cols-2 grid-rows-none lg:grid-rows-2 gap-x-2 lg:gap-4 h-[650px]">
                        <div className="col-span-2 lg:col-span-1 lg:row-span-2 overflow-hidden rounded-tr-[50px] lg:rounded-bl-[100px]">
                            <img
                                src="/img/imagen1.png"
                                alt="Imagen 1"
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <div className="col-span-1 row-span-1 lg:col-auto overflow-hidden rounded-bl-[50px] lg:rounded-tr-[50px] lg:rounded-bl-[50px]">
                            <img
                                src="/img/imagen2.png"
                                alt="Imagen 2"
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <div className="col-span-1 lg:col-auto overflow-hidden lg:rounded-tr-[50px] lg:rounded-bl-[50px]">
                            <img
                                src="/img/imagen3.png"
                                alt="Imagen 3"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>
                </div>
            </div>
 
            <div>
                <ProductosMain
                    api="masVendidos"
                    titulo="Más vendidos"
                    classNameTitulo="text-tertiary-personalize border-b-secondary-personalize"
                    classNameVermas="bg-tertiary-personalize text-white"
                />
                <div className="">
                    <img
                        src="/img/imagen4.png"
                        alt="Imagen 4"
                        className="w-full h-96 object-cover object-top"
                    />
                    <div className="bg-tertiary-personalize py-6">
                        <ProductosMain
                            api="ultimosAgregados"
                            titulo="Últimos Agregados"
                            classNameTitulo="text-white border-b-white"
                            classNameVermas="bg-white text-tertiary-personalize"
                        />
                    </div>
                </div>
            </div>

            <FooterPage />
        </div>
    );
};

export default Main;
